import { Container, Wrapper, ContentContainer, HeadingContainer, BodyContainer,Heading, Body, ButtonContainer, PearContainer } from './TcamStatic.style';
import { renderParagraph } from 'components/utils/render';
import { Button } from 'components/common';
import TcamPear from './TcamPear';
interface Props {
    heading: string;
    text: any;
    btnText?: string;
    btnLink?: string;
}

const TcamStatic = ({heading, text, btnText, btnLink}: Props) => {
  return (
    <Container>
        <Wrapper>
            <ContentContainer>
                <HeadingContainer>
                    <Heading>{heading}</Heading>
                </HeadingContainer>
                <BodyContainer>
                    <Body>{renderParagraph(text)}</Body>
                    {btnText && <ButtonContainer><Button btnType='tcamUp' btnText={btnText} btnLink={btnLink}/></ButtonContainer>}
                </BodyContainer>
            </ContentContainer>
            <PearContainer>
                <TcamPear hasAnimation={false} link={btnText && btnLink && btnLink !== ''? btnLink : undefined}/>
            </PearContainer>
        </Wrapper>
    </Container>
  )
};

export default TcamStatic;

